/**
 * Domain Registrant Endpoint
 */

import { DreamscapeClient } from '../client';
import {
  DomainRegistrantExisting,
  DomainRegistrantCreate,
  DomainRegistrantUpdate,
  Collection,
} from '../types';

export class DomainRegistrantEndpoint {
  constructor(private client: DreamscapeClient) {}

  /**
   * Get all registrants
   */
  async getAll(filters?: { page?: number; limit?: number }): Promise<Collection<DomainRegistrantExisting>> {
    const params: Record<string, any> = {};
    if (filters?.page) params.page = filters.page;
    if (filters?.limit) params.limit = filters.limit;

    return this.client.request<Collection<DomainRegistrantExisting>>(
      'GET',
      'domains/registrants',
      undefined,
      params
    );
  }

  /**
   * Get registrant details
   */
  async getDetails(registrantId: number): Promise<DomainRegistrantExisting> {
    if (registrantId < 1) {
      throw new Error('Registrant ID must be a positive integer');
    }

    return this.client.request<DomainRegistrantExisting>('GET', `domains/registrants/${registrantId}`);
  }

  /**
   * Create registrant
   */
  async create(data: DomainRegistrantCreate): Promise<DomainRegistrantExisting> {
    const requestData: any = {
      first_name: data.firstName,
      last_name: data.lastName,
      email: data.email,
      phone: data.phone,
      address: data.address,
      city: data.city,
      state: data.state,
      post_code: data.postCode,
      country: data.country,
      country_code: data.countryCode,
      account_type: data.accountType,
    };

    if (data.businessName) requestData.business_name = data.businessName;
    if (data.businessNumber) requestData.business_number = data.businessNumber;
    if (data.businessNumberType) requestData.business_number_type = data.businessNumberType;

    return this.client.request<DomainRegistrantExisting>('POST', 'domains/registrants', requestData);
  }

  /**
   * Update registrant
   */
  async update(registrantId: number, data: DomainRegistrantUpdate): Promise<DomainRegistrantExisting> {
    if (registrantId < 1) {
      throw new Error('Registrant ID must be a positive integer');
    }

    const requestData: any = {};
    if (data.firstName) requestData.first_name = data.firstName;
    if (data.lastName) requestData.last_name = data.lastName;
    if (data.email) requestData.email = data.email;
    if (data.phone) requestData.phone = data.phone;
    if (data.address) requestData.address = data.address;
    if (data.city) requestData.city = data.city;
    if (data.state) requestData.state = data.state;
    if (data.postCode) requestData.post_code = data.postCode;
    if (data.country) requestData.country = data.country;

    return this.client.request<DomainRegistrantExisting>(
      'PATCH',
      `domains/registrants/${registrantId}`,
      requestData
    );
  }
}

